import React from 'react';
import PropTypes from 'prop-types';
var spreadAttendees = function spreadAttendees(attendees) {
  var result = [];
  if (attendees.consultant) {
    result.push("".concat(attendees.consultant, " (Consultant)"));
  }

  // the following can be done with a .push(...invitees)
  attendees.invitees.forEach(function (i) {
    return result.push(i);
  });
  if (attendees.requester) {
    result.push("".concat(attendees.requester, " (Organizer)"));
  }
  return result;
};
function InterviewAttendees(_ref) {
  var attendees = _ref.attendees,
    _ref$horizontal = _ref.horizontal,
    horizontal = _ref$horizontal === void 0 ? false : _ref$horizontal,
    _ref$consultantView = _ref.consultantView,
    consultantView = _ref$consultantView === void 0 ? false : _ref$consultantView;
  // attendees comes to us as a hash
  var attendeesList = spreadAttendees(attendees);
  if (consultantView) {
    return /*#__PURE__*/React.createElement("div", {
      className: "interview-attendees-container muted-gray-text"
    }, /*#__PURE__*/React.createElement("div", {
      className: "interview-attendees-label body-text-2 mb-4"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-users me-3"
    })), attendeesList.length, ' ', "guests"));
  }
  if (horizontal) {
    var attendeesStr = attendeesList.join(', ');
    return /*#__PURE__*/React.createElement("div", {
      className: "interview-attendees-container muted-gray-text"
    }, /*#__PURE__*/React.createElement("div", {
      className: "interview-attendees-label body-text-2 mb-4"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-users me-3"
    })), attendeesList.length, ' ', "guests:", attendeesStr));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "interview-attendees-container muted-gray-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "interview-attendees-label body-text-2 mb-4"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-users me-2"
  })), attendeesList.length, ' ', "guests:"), /*#__PURE__*/React.createElement("div", {
    className: "interview-attendees-list ms-4"
  }, attendeesList.map(function (attendee) {
    return /*#__PURE__*/React.createElement("div", {
      className: "body-text-2 mb-3",
      key: attendee
    }, attendee);
  })));
}
InterviewAttendees.propTypes = {
  attendees: PropTypes.shape({
    consultant: PropTypes.string,
    invitees: PropTypes.arrayOf(PropTypes.string),
    requester: PropTypes.string
  }).isRequired,
  horizontal: PropTypes.bool,
  consultantView: PropTypes.bool
};
InterviewAttendees.defaultProps = {
  horizontal: false,
  consultantView: false
};
export default InterviewAttendees;